import { frontendURL } from 'dashboard/helper/URLHelper';

const BroadcastsRouteView = () => import('./pages/BroadcastsRouteView.vue');
const BroadcastsFormPage = () => import('./pages/BroadcastsFormPage.vue');
const BroadcastsDetailPage = () => import('./pages/BroadcastsDetailPage.vue');

const meta = {
  permissions: [
    'administrator',
    'broadcast_view',
    'broadcast_create',
    'broadcast_manage',
  ],
};

const broadcastsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/broadcasts'),
      component: BroadcastsRouteView,
      children: [
        {
          path: '',
          name: 'broadcasts_index',
          redirect: to => ({
            name: 'campaigns_index',
            params: { accountId: to.params.accountId },
          }),
        },
        {
          path: 'new',
          name: 'broadcasts_new',
          meta,
          component: BroadcastsFormPage,
        },
        {
          path: ':broadcastId',
          name: 'broadcasts_show',
          meta,
          component: BroadcastsDetailPage,
        },
        {
          path: ':broadcastId/edit',
          name: 'broadcasts_edit',
          meta,
          component: BroadcastsFormPage,
        },
      ],
    },
  ],
};

export default broadcastsRoutes;
